import type { RpsHand } from "@/lib/types";
import { HANDS } from "../utils";

interface Props {
  onPick: (hand: RpsHand) => void;
  disabled?: boolean;
}

// 참여용 큰 버튼 3개 (가로). 높이 72px 이상, 이모지 크게.
export default function HandPickButtons({ onPick, disabled = false }: Props) {
  return (
    <div className="grid grid-cols-3 gap-2.5">
      {HANDS.map((h) => (
        <button
          key={h.code}
          type="button"
          onClick={() => onPick(h.code)}
          disabled={disabled}
          className="flex min-h-[88px] flex-col items-center justify-center gap-1.5 rounded-xl border border-background-200 bg-background-50 text-base font-bold text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 disabled:opacity-50"
        >
          <span className="text-4xl leading-none" aria-hidden="true">
            {h.emoji}
          </span>
          {h.label}
        </button>
      ))}
    </div>
  );
}